export default "__VITE_ASSET__BTj3Fgog__"